import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../store/AppContext.js';
import { Alert } from '../components/ui.js';
import { PasswordStrength } from '../components/PasswordStrength.js';
import { MfaRequiredError } from '../crypto/session.js';

export function Login() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mfa, setMfa] = useState('');
  const [showMfa, setShowMfa] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim().toLowerCase(), password, showMfa ? mfa : undefined);
      navigate('/vault');
    } catch (err) {
      if (err instanceof MfaRequiredError) {
        setShowMfa(true);
        setError('Enter your 6-digit authenticator code.');
      } else {
        setError(err instanceof Error ? err.message : 'Login failed');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="panel auth-card">
        <div className="brand" style={{ padding: '0 0 18px' }}><span className="logo">🔐</span> Battini <span className="gradient-text">Vault</span></div>
        <h2 style={{ margin: '0 0 4px' }}>Welcome back</h2>
        <p className="muted" style={{ marginTop: 0, fontSize: 14 }}>Decrypt your vault locally. Your master password never leaves this device.</p>

        {error && <Alert kind={showMfa ? 'info' : 'error'}>{error}</Alert>}

        <form onSubmit={submit}>
          <div className="field">
            <label>Email</label>
            <input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="field">
            <label>Master password</label>
            <div className="password-input">
              <input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {password && <div className="mt-sm"><PasswordStrength password={password} /></div>}
          </div>
          {showMfa && (
            <div className="field">
              <label>Authenticator code</label>
              <input inputMode="numeric" maxLength={6} value={mfa} onChange={(e) => setMfa(e.target.value.replace(/\D/g, ''))} required />
            </div>
          )}
          <button className="btn full" disabled={busy}>{busy ? 'Unlocking…' : showMfa ? 'Verify & unlock' : 'Unlock vault'}</button>
        </form>

        <div className="flex between mt" style={{ fontSize: 13 }}>
          <Link to="/register">Create account</Link>
          <Link to="/reset-password">Forgot password?</Link>
        </div>
      </div>
    </div>
  );
}
